export default __webpack_public_path__ + "static/media/details_img.be666cd9.png";